import { z } from 'zod';
import { toast } from 'sonner';

export function handleAuthStateChange(error: unknown): void {
  if (error instanceof z.ZodError) {
    console.error('Auth state validation error:', error.errors);
    toast.error('Invalid user data format. Please contact support.');
    return;
  }

  if (error instanceof Error) {
    console.error('Auth state change error:', error.message);
    toast.error('Authentication error. Please try again.');
    return;
  }

  console.error('Auth state error:', error);
  toast.error('An unexpected error occurred');
}